import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PublicPage from './PublicPage';
import usePageTitle from '../../hooks/usePageTitle';
import { SITE } from '../../config/site';
import './LegalPage.css';

// Shared layout for the Terms and the Privacy Policy: a plain-language summary first, then a contents list and
// numbered sections, with the version and date so it is clear which text applies.
const LegalPage = ({ title, description, summary, sections }) => {
  usePageTitle(title, description);

  return (
    <PublicPage>
      <article className="legal">
        <div className="public-container legal__head">
          <p className="legal__meta">
            Version {SITE.termsVersion} · Last updated {SITE.termsUpdated}
          </p>
          <h1>{title}</h1>

          {summary && (
            <aside className="legal__summary" aria-label="The short version">
              <h2>The short version</h2>
              <ul>{summary.map((point) => <li key={point}>{point}</li>)}</ul>
              <p>This summary is a guide. The full text below is what applies.</p>
            </aside>
          )}
        </div>

        <div className="public-container legal__layout">
          <nav className="legal__toc" aria-label="Contents">
            <h2>Contents</h2>
            <ol>
              {sections.map((s) => (
                <li key={s.id}><a href={`#${s.id}`}>{s.title}</a></li>
              ))}
            </ol>
          </nav>

          <div className="legal__body">
            {sections.map((s, i) => (
              <section key={s.id} id={s.id} aria-labelledby={`${s.id}-title`}>
                <h2 id={`${s.id}-title`}>{i + 1}. {s.title}</h2>
                {s.body}
              </section>
            ))}
            <p className="legal__end">
              Questions about this document? <Link to="/contact">Contact us</Link>.
            </p>
          </div>
        </div>
      </article>
    </PublicPage>
  );
};

LegalPage.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  summary: PropTypes.arrayOf(PropTypes.string),
  sections: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string.isRequired, title: PropTypes.string.isRequired, body: PropTypes.node.isRequired })
  ).isRequired
};

export default LegalPage;
